/* eslint-disable import/extensions */
/* eslint-disable no-console */
/* eslint-disable quote-props */
/* eslint-disable no-undef */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { http, } from '@/helpers/index';
import QuickInquiry from '@/components/quick-inquiry';
import Seo from '@/components/seo';
import { auth } from '@/services/auth';

function InquiryQuick({ warning, product, plate, tag, }) {
  const productName = product?.name;
  const pageTitle = product
    ? `Consulta ${productName} por Placa | AboutCar`
    : 'Consulta Não Encontrada | AboutCar';
  const pageDescription = product?.description
    ? `Faça a Consulta ${productName} por placa na AboutCar. ${product.description}`
    : 'A consulta veicular solicitada não foi encontrada na AboutCar. Confira nossas opções disponíveis de consultas por placa.';

  const productSchema = product ? {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: `Consulta Veicular ${productName}`,
    description: pageDescription,
    brand: {
      '@type': 'Brand',
      name: 'AboutCar'
    },
    offers: {
      '@type': 'Offer',
      price: product.price || '0.00',
      priceCurrency: 'BRL',
      availability: 'https://schema.org/InStock'
    }
  } : null;

  return (
    <>
      <Seo
        title={pageTitle}
        description={pageDescription}
        keywords={`consulta ${productName?.toLowerCase()}, consultar placa ${productName?.toLowerCase()}, laudo veicular placa, historico veiculo`}
        schema={productSchema}
      />
      <QuickInquiry options={{ warning, product, plate, tag, }} />
    </>
  );
}

InquiryQuick.enableMessages = true;
export default InquiryQuick;

export async function getServerSideProps(context) {
  const { type, placa, tag } = context.query;

  const res = await http.baseAsync('GET', '/configurations');
  let warning = '';
  if (res.ok) {
    const item = await res.json();
    if (item && !item.vendors.checktudo.online) {
      warning = item.vendors.message;
    }
  }

  let typeOf = type;
  if (['leilao-completo', 'leilao', 'auction', 'gravame'].includes(type)) {
    typeOf = 'leilao-especial';
  }
  if (['indicio-sinistro', 'dados-nacionais', 'complete', 'especial', 'special', 'veiculo-plus', 'debitos-e-multas'].includes(type)) {
    typeOf = 'completa';
  }
  const resProduct = await http.baseAsync('GET', `/products/${typeOf}`, null, false, auth.headers());
  if (!resProduct.ok) {
    return { props: {}, };
  }
  const product = await resProduct.json();

  return { props: { warning, product, plate: placa || '', tag: tag || '', }, };
}
